function BlockUListService() {
    const CLASS_TITLE_ACTIVE = 'block-u-lista-servicios__content__list__title--active';
    const CLASS_CONTENT_ACTIVE = 'block-u-lista-servicios__content__list__content--active';
    let idInterval;
    let advance = 0;
    let lastContent;
    function init() {
        jQuery('.block-u-lista-servicios__content__list__content--small').slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            //centerMode: true,
            autoplaySpeed: 3000,
            arrows: false,
            dots: true,
            adaptiveHeight: true,
            pauseOnHover: false,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 2500,
                    settings: {
                        slidesToShow: 8,
                        centerPadding: '40px',
                    }
                },
                {
                    breakpoint: 1900,
                    settings: {
                        slidesToShow: 6,
                    }
                },
                {
                    breakpoint: 1366,
                    settings: {
                        slidesToShow: 5,
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                    }
                },
            ]
        });
        jQuery('.block-u-lista-servicios__content__list__title').on('click', viewTab)
        jQuery('.block-u-lista-servicios__content__list__content').on('mouseover', mouseoverList);
        jQuery('.block-u-lista-servicios__content__list__content').on('mouseout', mouseoutList);
    }
    function mouseoverList(evt) {
        const widthContent = jQuery(this).width();
        lastContent = this;
        const vel = 5;
        const { clientX } = evt;
        const x = clientX - ((window.innerWidth - widthContent) / 2);

        const percent = x / widthContent;
        advance = percent < .3 ? -vel : (percent > .7 ? vel : 0);
        
        mouseoutList();
        idInterval = setInterval(() => {
            animateScroll();
        }, 10)
    }
    function mouseoutList() {
        if (idInterval) {
            clearInterval(idInterval);
        }
    }
    function animateScroll() {
        if (!advance) {
            return;
        }
        const element = jQuery(lastContent);
        const x = element.scrollLeft();
        element.scrollLeft(x + advance);

    }
    function viewTab(evt) {
        const element = jQuery(this);
        const idElement = element.data('content');
        jQuery('.block-u-lista-servicios__content__list__content').removeClass(CLASS_CONTENT_ACTIVE);
        jQuery('.block-u-lista-servicios__content__list__title').removeClass(CLASS_TITLE_ACTIVE);

        jQuery('#' + idElement).addClass(CLASS_CONTENT_ACTIVE);
        element.addClass(CLASS_TITLE_ACTIVE);
        jQuery('.block-u-lista-servicios__content__list__content').slick('setPosition');

        //setTimeout(() => { window.dispatchEvent(new Event('resize')) }, 1);
    }
    init();
}
new BlockUListService();